import { SxProps } from '@mui/material';

import { avatarSizeMap } from '../Avatar/styled';
import { AvatarSize } from '../Avatar/types';

/**
 * Get surplus styles for the AvatarGroup component
 *
 * @param size Size of the avatars in the group
 *
 * @returns    Styles for the surplus avatars
 */
export const getSurplusStyles = (size: AvatarSize): SxProps => {
  const avatarSize = avatarSizeMap[size];

  return {
    '&.MuiAvatarGroup-avatar': {
      '&:hover': {
        borderColor: 'transparent',
      },
      backgroundColor: 'transparent',
      color: 'var(--color-grey-darkest)',
      height: avatarSize,
      margin: 0,
      width: avatarSize,
    },
  };
};
